import Checkbox from "./Checkbox.js";
import StandardSubSettings from "./StandardSubSettings";
import { InputNumber, Row, Space } from "antd";

const BrottsplatsKartanSettings = ({ settings, saveSettings }) => {
  let localSettings = StandardSubSettings(settings, "BrottsplatsKartan");
  let useArea = localSettings.useArea;

  return (
    <div>
      <Checkbox
        name="BrottsplatsKartanArea"
        text="Visa bara information om ditt län"
        def={useArea}
        onChange={() => {
          useArea = !useArea;
          localSettings.useArea = useArea;
          saveSettings(localSettings);
        }}
      />
      <Row style={{ padding: "10px" }}>
        <Space>
          <p style={{ margin: "10px 0px 0px 0px" }}>
            {" "}
              Avisera om ny data finns inom:{" "}
          </p>
          <InputNumber
            min={0}
            defaultValue={localSettings.newDataHour}
            onChange={(value) => {
              if(value ===null){value=0;}
              localSettings.newDataHour = value;
              saveSettings(localSettings);
            }}
            step={0.5}
          />
          <p style={{ margin: "10px 0px 0px 0px" }}>timmar</p>
        </Space>
      </Row>
    </div>
  );
};

export default BrottsplatsKartanSettings;
